const DISCUSSIONS_ROUTES = Object.freeze({
  backoffice:
    Routes.fetch_discussions_backoffice_network_dynamic_components_search_index_path,
  frontoffice: Routes.fetch_discussions_dynamic_components_search_index_path,
  publicoffice: Routes.fetch_discussions_dynamic_components_search_index_path,
});

const EVENTS_ROUTES = Object.freeze({
  backoffice:
    Routes.fetch_events_backoffice_network_dynamic_components_search_index_path,
});

const TOPICS_ROUTES = Object.freeze({
  backoffice:
    Routes.fetch_topics_backoffice_network_dynamic_components_search_index_path,
  frontoffice: Routes.fetch_topics_dynamic_components_search_index_path,
  publicoffice: Routes.fetch_topics_dynamic_components_search_index_path,
});

const NEWS_ROUTES = Object.freeze({
  backoffice:
    Routes.fetch_news_backoffice_network_dynamic_components_search_index_path,
});

const POSTS_ROUTES = Object.freeze({
  backoffice:
    Routes.fetch_posts_backoffice_network_dynamic_components_search_index_path,
});

const USERS_ROUTES = Object.freeze({
  backoffice:
    Routes.fetch_users_backoffice_network_dynamic_components_search_index_path,
  frontoffice: Routes.fetch_users_dynamic_components_search_index_path,
  publicoffice: Routes.fetch_users_dynamic_components_search_index_path,
});

export const USER_ROUTE = ({ networkId, userId }) =>
  Routes.preview_user_user_path(networkId, userId);

const ROUTES = Object.freeze({
  discussions: DISCUSSIONS_ROUTES,
  events: EVENTS_ROUTES,
  topics: TOPICS_ROUTES,
  news: NEWS_ROUTES,
  posts: POSTS_ROUTES,
  users: USERS_ROUTES,
});

const ROUTES_CATEGORIES = ({ ids }) =>
  Object.freeze({
    discussions:
      Routes.categories_backoffice_network_dynamic_components_search_index_path(
        ids.network,
        {
          categorized_type: 'Forums::Discussion',
          format: 'json',
          ...(ids.topic && { topic_id: ids.topic }),
        },
      ),
    events:
      Routes.categories_backoffice_network_dynamic_components_search_index_path(
        ids.network,
        {
          categorized_type: 'NetworkEvents::Event',
          format: 'json',
          ...(ids.topic && { topic_id: ids.topic }),
        },
      ),
    topics:
      Routes.topic_categories_backoffice_network_dynamic_components_search_index_path(
        ids.network,
        {
          format: 'json',
          ...(ids.topic && { topic_id: ids.topic }),
        },
      ),
    news: Routes.categories_backoffice_network_dynamic_components_search_index_path(
      ids.network,
      {
        categorized_type: 'Communications::News',
        format: 'json',
        ...(ids.topic && { topic_id: ids.topic }),
      },
    ),
    posts:
      Routes.categories_backoffice_network_dynamic_components_search_index_path(
        ids.network,
        {
          categorized_type: 'Posts::FeedPost',
          format: 'json',
        },
      ),
  });

export const pagesAndEmailsRoutes = { ROUTES, ROUTES_CATEGORIES, USER_ROUTE };
